import React from 'react';
import customerAppProfile from './images/shared_image_(12).jpg';
import vendorAppProfile from './images/shared_image_(11).jpg';

const HighlightSection = () => {
    return (
        <section className="highlight-section" id="dashboard">
            <div className="container highlight-container">
                <div className="highlight-text reveal">
                    <div className="section-eyebrow">Salon Profiles</div>
                    <h2>Showcase your brand natively</h2>

                    <div className="big-feature-text">
                        <i className="fa-solid fa-check-circle"></i>
                        Every salon has its own profile page.
                    </div>

                    <p className="highlight-lead">
                        When a user opens the Customer App, they don't just see a booking form—they see your custom
                        brand identity with interactive salon details. Let your business shine independently on our
                        platform.
                    </p>

                    <ul className="highlight-points">
                        <li>
                            <div className="hp-icon"><i className="fa-solid fa-share-nodes"></i></div>
                            Shareable profile link for social media (e.g., Instagram, Facebook)
                        </li>
                        <li>
                            <div className="hp-icon"><i className="fa-solid fa-clock-rotate-left"></i></div>
                            Display live opening &amp; closing times
                        </li>
                        <li>
                            <div className="hp-icon"><i className="fa-solid fa-location-dot"></i></div>
                            Integrated location, email, and phone contact points
                        </li>
                    </ul>
                </div>

                <div className="highlight-image reveal" style={{ transitionDelay: '0.2s' }}>
                    <div className="phones-wrapper">
                        <div className="phone-mockup phone-mockup-1">
                            <div className="phone-notch"></div>
                            <img src={customerAppProfile} alt="Customer App View"
                                style={{ width: '100%', height: 'auto', display: 'block' }} />
                        </div>

                        <div className="phone-mockup phone-mockup-2">
                            <div className="phone-notch"></div>
                            <img src={vendorAppProfile} alt="Vendor App View"
                                style={{ width: '100%', height: 'auto', display: 'block' }} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HighlightSection;
